import {Injectable} from '@angular/core';
import {Mutation} from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class DeleteTerminalMutation extends Mutation {
  document = gql`
      mutation deleteTermnial($id: ID!) {
          deleteTerminal(where: {id: $id}) {
              id
          }
      }
  `;
}
